import React from 'react';
import { useNavigate } from 'react-router-dom';

const Goal8 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/#sdg-goals');
  };
  return (
    <div className="container mx-auto px-4 py-8">
      <button
        onClick={handleGoBack}
        className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </button>
      <h2 className="text-3xl font-bold mb-4">SDG 8 Decent Work and Economic Growth</h2>
      <p className="text-lg mb-4">
        Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all.
      </p>
      <a
        href="https://sdg-tracker.org/economic-growth"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        https://sdg-tracker.org/economic-growth
      </a>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Targets</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.1</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Sustainable economic growth</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Sustain per capita economic growth in accordance with national circumstances and, in particular, at least 7 per cent gross domestic product growth per annum in the least developed countries.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.2</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Diversify, innovate and upgrade for economic productivity</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Achieve higher levels of economic productivity through diversification, technological upgrading and innovation, including through a focus on high-value added and labour-intensive sectors.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.3</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Promote policies to support job creation and growing enterprises</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Promote development-oriented policies that support productive activities, decent job creation, entrepreneurship, creativity and innovation.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.4</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Improve resource efficiency in consumption and production</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Improve progressively, through 2030, global resource efficiency in consumption and production and endeavour to decouple economic growth from environmental degradation, in accordance with the 10‑Year Framework of Programs on Sustainable Consumption and Production, with developed countries taking the lead.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.5</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Full employment and decent work with equal pay</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, achieve full and productive employment and decent work for all women and men, including for young people and persons with disabilities, and equal pay for work of equal value.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.6</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Promote youth employment, education and training</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, substantially reduce the proportion of youth not in employment, education or training.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.7</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">End modern slavery, trafficking, and child labour</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Take immediate and effective measures to eradicate forced labour, end modern slavery and human trafficking and secure the prohibition and elimination of the worst forms of child labour, including recruitment and use of child soldiers, and by 2025 end child labour in all its forms.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.8</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Protect labour rights and promote safe working environments</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Protect labour rights and promote safe and secure working environments for all workers, including migrant workers, in particular women migrants, and those in precarious employment.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.9</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Promote beneficial and sustainable tourism</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, devise and implement policies to promote sustainable tourism that creates jobs and promotes local culture and products.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.10</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Universal access to banking, insurance and financial services</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Strengthen the capacity of domestic financial institutions to encourage and expand access to banking, insurance and financial services for all.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.A</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Increase aid for trade support</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Increase Aid for Trade support for developing countries, in particular, least developed countries, including through the Enhanced Integrated Framework for Trade-related Technical Assistance to Least Developed Countries.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">8.B</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Develop a global youth employment strategy</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, develop and operationalize a global strategy for youth employment and implement the Global Jobs Pact of the International Labour Organization.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Goal8;
